import React from 'react';
import { styled } from '@material-ui/styles';
import Button from '@material-ui/core/Button';
import Colors from './Colors';

/**
 * Button styles
 *
 * By defining all of our custom styled button components in one place, we can easily swap theming without affecting
 * functionality, using MUI styles (avoids issues with trying to overwrite injected styles through CSS)
 */

const margins = { marginLeft: '8px', marginRight: '8px'};
const textColor = {color: Colors.contrastText};

const commonStyling = {...margins, ...textColor};

const PrimaryContainedButton = styled(Button)({
    background: Colors.primary,
    ...commonStyling,
    '&:hover': {
        background: Colors.primaryHover,
    }
});

const PrimaryDarkContainedButton = styled(Button)({
    background: Colors.primaryDark,
    ...commonStyling,
    '&:hover': {
        background: Colors.primaryDarkHover,
    }

});

const SecondaryContainedButton = styled(Button)({
    background: Colors.secondary,
    ...commonStyling,
    '&:hover': {
        background: Colors.secondaryHover,
    }
});

/**
 * Builder function, takes a component and a set of props and creates the given component with those props.
 * Useful for quickly generating buttons.
 * @param Component
 * @param props
 * @returns {*}
 * @constructor
 */
function BuildCustomComponent({component : Component}, props){
    const {variant, ...restProps} = props;
    return <Component variant={variant ? variant : ''} {...restProps}>{props.children}</Component>;
}

export let PrimaryButton = (props) => BuildCustomComponent({component: PrimaryContainedButton}, {variant: 'contained', ...props});
export let PrimaryDarkButton = (props) => BuildCustomComponent({component: PrimaryDarkContainedButton}, {variant: 'contained', ...props});
export let SecondaryButton = (props) => BuildCustomComponent({component: SecondaryContainedButton}, {variant: 'contained', ...props});
